import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../endpoints'

export async function getCarlotsByCatalog(catalog_id) {
    const response = await axios.get(`${REACT_APP_API_ABM_FW}/abms/car_lot/getByCatalogId/${catalog_id}`)
    return response?.data?.carLots
}